import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65970f2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "single-job-offer"
}
const _hoisted_2 = { class: "single-job container" }
const _hoisted_3 = { class: "container header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_5 = { class: "h2" }
const _hoisted_6 = { class: "text-primary" }
const _hoisted_7 = { class: "container content" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { key: 3 }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 4,
  class: "separator separator--sm"
}
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chips = _resolveComponent("chips")!
  const _component_page_headline = _resolveComponent("page-headline")!
  const _component_OpenPositionApply = _resolveComponent("OpenPositionApply")!

  return (_ctx.item)
    ? (_openBlock(), _createElementBlock("article", _hoisted_1, [
        _createVNode(_component_page_headline, {
          content: { ..._ctx.page, title: '*Role description*' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_chips, {
              chips: _ctx.item.domain
            }, null, 8, ["chips"])
          ]),
          _: 1
        }, 8, ["content"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.item.title), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.item.subtitle), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              (_ctx.item.roleDescription)
                ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                    _createElementVNode("div", {
                      class: "content ql-editor",
                      innerHTML: _ctx.item.roleDescription
                    }, null, 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.item.responsibilities)
                ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.page.attributes?.responsibilitiesTitle?.description), 1),
                    _createElementVNode("div", {
                      class: "content ql-editor",
                      innerHTML: _ctx.item.responsibilities
                    }, null, 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.item.requirements)
                ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.page.attributes?.requirements?.description), 1),
                    _createElementVNode("div", {
                      class: "content ql-editor",
                      innerHTML: _ctx.item.requirements
                    }, null, 8, _hoisted_13)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.item.yourExpect)
                ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.page.attributes?.yourExpect?.description), 1),
                    _createElementVNode("div", {
                      class: "content ql-editor",
                      innerHTML: _ctx.item.yourExpect
                    }, null, 8, _hoisted_15)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.page.texts?.jobOfferFooter?.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                : _createCommentVNode("", true),
              (_ctx.page.texts?.jobOfferFooter?.description)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 5,
                    class: "offer-footer-hint content ql-editor",
                    innerHTML: _ctx.page.texts?.jobOfferFooter?.description
                  }, null, 8, _hoisted_17))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("aside", null, [
              _createVNode(_component_OpenPositionApply)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}